import React, { useState } from "react";

import { Box, Button, Alert, Stack, AlertTitle, Link as MUILink } from "@mui/material";
import CustomAlert from "components/elements/CustomAlert";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useUserDataContext } from "context/UserDataContext";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SubscriptionType } from "types/enums";
import { getLocalStorageBooleanValue, isAtTierOrHigher } from "utils";

const AlertWrapper = ({ children }: { children: React.ReactNode }) => {
  const validChildren = React.Children.toArray(children).filter(Boolean);
  if (validChildren.length === 0) return null;

  return (
    <Box pb={validChildren.length > 0 ? 2 : 0} rowGap={1} display={"flex"} flexDirection="column" width={"100%"}>
      {validChildren}
    </Box>
  );
};

interface IProps {
  hasExchangeConnections?: boolean;
}

const SubscriptionInfo = ({ hasExchangeConnections }: IProps) => {
  const { t } = useTranslation();
  const { colors } = useMUIThemeModeContext();
  const { subscriptionPausedError, subscriptionPausedWarning, subscriptionType, subscriptionPaused } = useUserDataContext();
  const isPremium = isAtTierOrHigher(subscriptionType ?? SubscriptionType.FREE, SubscriptionType.PREMIUM);
  const [alertPremiumCall, setAlertPremiumCall] = useState<boolean>(getLocalStorageBooleanValue("showAlertPremiumCall3", true));

  const handleCloseAlert = () => {
    setAlertPremiumCall(false);
    localStorage.setItem("showAlertPremiumCall3", "false");
  };

  const premiumAlerts = () => {
    // if (!alertPremiumCall) return null;
    return null; // disabled for now

    return (
      <CustomAlert severity="premium" onClose={() => handleCloseAlert()}>
        <AlertTitle>
          <Trans>{`Komunitní call pro PREMIUM\u00a0uživatele`}</Trans>
        </AlertTitle>
        <Stack spacing={2}>
          <Box>
            <Trans>
              {`Po webináři proběhl další komunitní call, chceš si pustit `}
            </Trans>
            <MUILink href={`https://youtube.com/live/tErQcu_ajDU`} target={"_blank"}>
              záznam
            </MUILink>
            <Trans>{`? Křížkem toto oznámení zavřeš.`}</Trans>
          </Box>
        </Stack>
      </CustomAlert>
    );
  };

  return (
    <AlertWrapper>
      {subscriptionPausedError && (
        <Alert severity="error">
          <Stack spacing={2}>
            <Box>
              <Trans i18nKey="dashboard.subscriptionError" />
              {" "}
              <Trans i18nKey="dashboard.subscriptionFree" />
            </Box>
            <Box>
              <Stack spacing={1} direction={{xs: "column", sm: "row"}}>
                <Button
                  component={Link}
                  to="/stosaky#mesicni-platba"
                  variant="contained"
                  size="small"
                  color="error">
                  {t("dashboard.subscriptionCtaBuyCredits")}
                </Button>
                <Button
                  component={Link}
                  to="/stosaky#predplatne"
                  variant="outlined"
                  size="small"
                  color="error">
                  {t("dashboard.subscriptionCtaFree")}
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Alert>
      )}
      {subscriptionPausedWarning && (
        <Alert severity="warning">
          <Stack spacing={2}>
            <Box>
              <Trans i18nKey="dashboard.subscriptionWarning" />
              {" "}
              <Trans i18nKey="dashboard.subscriptionFree" />
            </Box>
            <Box>
              <Stack spacing={1} direction={{xs: "column", sm: "row"}}>
                <Button
                  component={Link}
                  to="/stosaky#mesicni-platba"
                  variant="contained"
                  size="small">
                  {t("dashboard.subscriptionCtaBuyCredits")}
                </Button>
                <Button
                  component={Link}
                  to="/stosaky#predplatne"
                  variant="outlined"
                  size="small">
                  {t("dashboard.subscriptionCtaFree")}
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Alert>
      )}
      {isPremium && !subscriptionPaused && premiumAlerts()}
    </AlertWrapper>
  );
};

export default SubscriptionInfo;
